import React from 'react';
import { Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { KatBox, KatLink } from '@amzn/katal-react';
import { renderToString } from 'react-dom/server';
import { CountryCode, getBREnrollUrl, getBRUrl } from '../urls-config';

const BR_IMAGE_URL = 'https://m.media-amazon.com/images/G/01/brandregistry/v2/illustrations-final/Homepage_-_Protect_Brand_1.png';

interface BrandRegistryInfoAlertBoxProps {
  domainCountryCode: CountryCode;
}

export const BrandRegistryInfoAlertBox:
React.FC<BrandRegistryInfoAlertBoxProps> = (props: BrandRegistryInfoAlertBoxProps) => {
  const { t } = useTranslation('pnf_website_components');
  const {
    domainCountryCode,
  } = props;

  const brInfoHtmlContent = t('public-notice-form-brand-registry-info', {
    brEnrollLink: '{{brEnrollLink}}',
    brLink: '{{brLink}}',
  }).replace(
    '{{brEnrollLink}}',
    renderToString(
      <KatLink
        aria-label="Click here to enroll in brand registry"
        href={getBREnrollUrl(domainCountryCode)}
        target="_blank"
      >
        {t('public-notice-form-brand-registry-label')}
      </KatLink>
    )
  ).replace(
    '{{brLink}}',
    renderToString(
      <KatLink
        aria-label="Click here to visit brand registry"
        href={getBRUrl(domainCountryCode)}
        target="_blank"
      >
        {t('public-notice-form-amazon-brand-registry-label')}
      </KatLink>
    )
  );

  return (
    <KatBox className="br-info-box" variant="azure">
      <Row className="br-image">
        <img
          alt={BR_IMAGE_URL}
          src={BR_IMAGE_URL}
        />
      </Row>
      <Row noGutters>
        <h3>{t('public-notice-form-brand-registry-info-header')}</h3>
      </Row>
      <Row noGutters>
        <span dangerouslySetInnerHTML={{ __html: brInfoHtmlContent }} />
      </Row>
    </KatBox>
  );
};
